// extracted by mini-css-extract-plugin
module.exports = {"knowUsSection":"_2j-qs","withOutFeatures":"z4jQn","featuresSection":"_1A-fb","withShadow":"_31jbK"};